/** sendProductBulk ProductSelectionStep ile aynı seçilebilirlik kuralları */

function readArray(value) {
  return Array.isArray(value) ? value : [];
}

function matchesSelectedPlace(item, { marketPlaceId, ecommercePlaceId } = {}) {
  if (marketPlaceId != null && marketPlaceId !== "") {
    return (
      item?.marketPlaceId == marketPlaceId ||
      item?.marketPlace?.id == marketPlaceId
    );
  }
  if (ecommercePlaceId != null && ecommercePlaceId !== "") {
    return (
      item?.ecommercePlaceId == ecommercePlaceId ||
      item?.ecommercePlace?.id == ecommercePlaceId
    );
  }
  return true;
}

export function normalizeBulkSendProduct(
  product,
  { marketPlaceId, ecommercePlaceId } = {}
) {
  if (!product || typeof product !== "object") return product;

  const placeContext = { marketPlaceId, ecommercePlaceId };
  const allPlaces = readArray(
    product.productPlaces ?? product.ProductPlaces
  );
  const allTransfers = readArray(
    product.productPlaceTransfers ??
      product.ProductPlaceTransfers ??
      product.transferHistories ??
      product.TransferHistories ??
      product.productTransferHistories ??
      product.ProductTransferHistories
  );

  const productPlaces = allPlaces.filter((item) =>
    matchesSelectedPlace(item, placeContext)
  );
  const productPlaceTransfers = allTransfers.filter((item) =>
    matchesSelectedPlace(item, placeContext)
  );

  return {
    ...product,
    productPlaces,
    productPlaceTransfers,
  };
}

export function isProductSendable(product) {
  const places = product?.productPlaces ?? [];
  const transfers = product?.productPlaceTransfers ?? [];

  if (places.length > 0) return false;
  if (transfers.length > 0) {
    // Eski ProductSelectionStep ile aynı: status == 9 (loose)
    return transfers[0]?.status == 9;
  }
  return true;
}

export function isProductSelectionDisabled(product) {
  return !isProductSendable(product);
}

export function getSendBlockReason(product) {
  if (!isProductSelectionDisabled(product)) return null;
  return "Ürün pazaryerinde var veya süreci devam ediyor.";
}

export function filterSendableProducts(products) {
  if (!Array.isArray(products)) return [];
  return products.filter(isProductSendable);
}
